// extracted by mini-css-extract-plugin
var _1 = "Service_button__WNMoL";
var _2 = "Service_sorting__lbuba";
export { _1 as "button", _2 as "sorting" }
